"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _options = require("../options");

function _default() {
  var _getOptions = (0, _options.getOptions)(),
      getJWT = _getOptions.getJWT;

  return getJWT();
}